/**
 * The foot of every page: how many people use MyRave (the user, 2026-10-27).
 * The number is the server's (`usePeopleCount`). RAVERS, not people (the user).
 */
import { useLocale } from '@/app/LocaleProvider';
import { usePeopleCount } from '@/lib/publicSite';
import { localNumber } from '@/ui';
import { useT } from '@/i18n';

export function PeopleCount({ className }: { className?: string }) {
  const tr = useT();
  const { locale } = useLocale();
  const people = usePeopleCount();
  if (people === null) return null;
  return (
    <span className={className ?? 'shell-foot-people'}>
      <span aria-hidden="true">👁</span> {tr('{count} ravers use this app', { count: localNumber(locale, people) })}
    </span>
  );
}
